import { queryBot, queryBot2, queryBot3 } from 'boot/axios';
import { Users } from 'src/model/db/users';
import { Tasks } from 'src/model/db/tasks';
import { Logs } from 'src/model/db/logs';
import unescapeSql from 'src/mixins/utils';

const moment = require('moment');

// eslint-disable-next-line import/prefer-default-export
export class Db {
    constructor (app) {
        if (app) {
            this.app = app;
            this.users = new Users(app);
            this.tasks = new Tasks(app);
            this.logs = new Logs(app);
        }
        this.error = undefined;
    }

    auth (hash) {
        this.error = undefined;
        return new Promise((resolve, reject) => {
            queryBot2('get-user-by-hash', { hash }).then((r) => {
                const u = r.data[0];
                // eslint-disable-next-line guard-for-in,no-restricted-syntax
                for (const prop in u) {
                    if (u[prop] === 'null' || u[prop] === null) {
                        u[prop] = '';
                    }
                }
                resolve(u);
            }).catch((e) => {
                this.error = e;
                reject(e);
            });
        });
    }

    // eslint-disable-next-line class-methods-use-this
    async serverNow () {
        let now = moment();
        await queryBot2('now').then((r) => {
            if (r.data[0]) {
                now = moment(r.data[0].now);
            }
        });
        return now;
    }

    // eslint-disable-next-line class-methods-use-this
    async insertObject (table, item) {
        // this.removeNull(item);
        let id;
        await queryBot3('insert', table, item).then((r) => {
            if (r.data.id) {
                id = r.data.id;
            } else {
                console.error(r.data);
            }
        });
        return id;
    }

    // eslint-disable-next-line class-methods-use-this
    async updateObject (table, item) {
        // this.removeNull(item);
        try {
            await queryBot3('update', table, item);
        } catch (e) {
            console.error(e);
        }
        return true;
    }

    // eslint-disable-next-line class-methods-use-this
    removeNull (json) {
        Object.keys(json).forEach((key) => {
            if (json[key] === null) {
                delete json[key];
            }
        });
    }

    // eslint-disable-next-line class-methods-use-this
    async debugLog (text) {
        const sql = `insert into debug_log (text) values ('${unescapeSql(text)}')`;
        await queryBot(sql);
        return true;
    }
}
